// extracted by mini-css-extract-plugin
export default {"root":"ModalFooterContainer_root__+70s2"};